<div class="calendar-container">
  <!-- Header -->
  <div class="d-flex justify-content-between align-items-center flex-wrap">
    <div>
      <div class=" p-3 rounded d-flex justify-content-between align-items-center flex-wrap ">
        <button class="btn" (click)="viewMode === 'month' ? prevMonth() : prevWeek()">
          <i class="fas fa-chevron-left head-tile"></i>
        </button>
        <button class="btn" (click)="viewMode === 'month' ? nextMonth() : nextWeek()">
          <i class="fas fa-chevron-right head-tile"></i>
        </button>
        <h2 class="h4 mb-0 head-tile">
          {{ currentDate | date: (viewMode === 'month' ? 'MMMM yyyy' : 'dd MMM – ' + getEndOfWeek(currentDate)) }}
        </h2>
      </div>
    </div>
    <div class="view-switch">
      <i class="fas fa-spinner fa-spin feedback-loading" *ngIf="pendingFeedbackRequests > 0"></i>
      <button
        type="button"
        class="btn view-switch-btn"
        [class.active]="dataView === 'reservation'"
        (click)="setDataView('reservation')"
      >
        <i class="fas fa-calendar-check"></i> <span class="switch-label">Reservierungen</span>
      </button>
      <button
        type="button"
        class="btn view-switch-btn"
        *ngxPermissionsOnly="['admin', 'viewFeedbacks']"
        [class.active]="dataView === 'feedback'"
        (click)="setDataView('feedback')"
      >
        <i class="fas fa-star"></i> <span class="switch-label">Feedback</span>
      </button>
    </div>
  </div>
  <!-- Calendar Body -->
  <div class="calendar-body">
    <ng-container [ngSwitch]="viewMode">
      <!--  MONTH VIEW -->
      <ng-container *ngSwitchCase="'month'">
        <div class="calendar-grid">
          <!-- Header row -->
          <div style="display: flex;">
            <div
              class="calendar-day header"
              *ngFor="let d of ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag']"
            >
              {{ d }}
            </div>
          </div>
          <!-- Calendar rows -->
          <div *ngFor="let week of weeks" class="calendar-week">
            <div class="calendar-row">
              <div
                *ngFor="let day of week.days"
                class="calendar-day-cell flex-fill fw-bold py-2 border-start"
                [ngClass]="{
                  'other-month': !day.isCurrentMonth,
                  today: day.isToday,
                  selected: day.date?.toDateString() === selectedDate.toDateString(),
                  'has-alerts': day.alerts && day.alerts.length,
                  mdate: !!day.date
                }"
                (click)="onDayClick(day, $event)"
              >
                <span> {{ day.date | date: 'd' }} </span>
                <button
                  class="btn btn-sm"
                  *ngIf="day?.date"
                  [title]="dataView === 'feedback' ? 'Feedback dieses Tages öffnen' : 'Reservierungsbuch öffnen'"
                  (click)="
                    dataView === 'feedback' ? navigateToFeedback(day.date, $event) : navigateToBook(day.date, $event)
                  "
                >
                  <i class="fa fa-external-link" aria-hidden="true"></i>
                </button>
                <div *ngIf="dataView === 'reservation' && hasStats(day.date)" class="calendar-stats">
                  <div class="fs-2">
                    <span class="pr-3">
                      <i class="fas fa-calendar-check"></i>
                      {{ getStats(day.date).reservationCount }}
                    </span>
                    <i class="fas fa-users"></i>
                    {{ getStats(day.date).guestCount }}
                  </div>
                </div>
                <div *ngIf="dataView === 'feedback' && hasFeedback(day.date)" class="calendar-stats feedback-stats">
                  <div class="fs-2">
                    <span class="pr-3">
                      <i class="far fa-comment-dots"></i>
                      {{ getFeedbackStats(day.date).feedbackCount }}
                    </span>
                    <span [ngClass]="getRatingClass(getFeedbackStats(day.date).avgRating)">
                      {{ getFeedbackStats(day.date).avgRating | number: '1.1-1' }}
                      <i class="fas fa-star"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="calendar-bar-container label-text">
              <div
                *ngFor="let bar of week.bars; let i = index"
                class="calendar-bar"
                [ngStyle]="bar.style"
                [title]="bar.alert?.info"
              >
                <span class="eventBarText">
                  {{ bar.alert?.info }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
  <div *ngIf="selectedAlerts?.length" class="alert-details-popup">
    <div class="alert-header d-flex align-items-center justify-content-between mb-2">
      <h5 class="mb-0 flex-grow-1">
        <span *ngIf="selectedAlertDate"> {{ selectedAlertDate | date: 'fullDate' }} </span>
      </h5>
      <button class="btn btn-sm btn-outline-danger me-2" (click)="selectedAlerts = selectedAlertDate = null">
        <i class="fa-solid fa-xmark"></i>
      </button>
      <span style="width: 40px;"></span>
    </div>
    <div class="alert-scroll-container">
      <div *ngFor="let alert of selectedAlerts; let i = index" class="alert-box mb-3 border rounded">
        <span>
          <strong>Hinweis:</strong> {{ alert.info }} <strong>Datum von:</strong>
          {{ alert.dateFrom | date: 'shortDate' }}
          <span *ngIf="alert.dateTo !== null">
            <strong>Datum bis:</strong> {{ alert.dateTo | date: 'shortDate' }}
          </span>
        </span>
      </div>
    </div>
  </div>
</div>
